import ctx from '../../plugins/axios';

// eslint-disable-next-line import/no-anonymous-default-export
export default async (listUUID) => {
  return await ctx.get('/specialty-list-audit', {
    params: { list_uuid: listUUID },
  });
};
